import { PaymentResultContract } from 'models'
import { Subject } from 'rxjs'

export enum PaymentEventType {
    OnSettlementPaymentDeviceStatusChanged,
    OnSaleRefundIntegrationStatusChanged,
    OnSalePaymentIntegrationStatusChanged,
    OnSalePaymentIntegrationStatusCreated,
}

export interface PaymentEventArg {
    type: PaymentEventType
    params: PaymentResultContract
}

const PaymentEvent = new Subject<PaymentEventArg>()

export default PaymentEvent
